import React from "react";
import "./LoadingSpiner.scss";
const LoadingSpiner = () => {
  return (
    <div className="loading-state-spinner">
      <div className="loading-spinner"></div>
    </div>
  );
};

export default LoadingSpiner;
